// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { DataView, getDataView, getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { flattenFormattedParamsToApi } from "@pace/App/Handlers/xPreviouslyPurchased/LoadPreviouslyPurchased";
import { PreviouslyPurchasedApiParameter } from "@pace/App/Services/PreviouslyPurchasedService";
import { CustomAppState } from "@pace/App/Store/Reducers";

export function getPreviouslyPurchasedDataView(
    state: CustomAppState,
    previouslyPurchasedApiParameter: PreviouslyPurchasedApiParameter,
) {
    const formattedApiFilters = flattenFormattedParamsToApi(previouslyPurchasedApiParameter);
    return getDataView(state.xPreviouslyPurchased, formattedApiFilters);
}

export function getPreviouslyPurchasedDataProp<K extends keyof Omit<DataView, "ids">>(
    state: CustomAppState,
    previouslyPurchasedApiParameter: PreviouslyPurchasedApiParameter,
    key: K,
) {
    const formattedApiFilters = flattenFormattedParamsToApi(previouslyPurchasedApiParameter);
    const previouslyDataView = getDataView(state.xPreviouslyPurchased, formattedApiFilters);
    return previouslyDataView.value ? previouslyDataView[key] : undefined;
}

export const getPreviouslyPurchaseProductsInfo = (
    state: CustomAppState,
    previouslyPurchasedApiParameter: PreviouslyPurchasedApiParameter,
) => {
    const formattedApiFilters = flattenFormattedParamsToApi(previouslyPurchasedApiParameter);
    const dataViewKey = getDataViewKey(formattedApiFilters);
    return state.components.productInfoLists.productInfoListById[dataViewKey]?.productInfoByProductId || {}
};
